import script from "./TermsConditions.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsConditions.vue?vue&type=script&setup=true&lang=js"

import "./TermsConditions.vue?vue&type=style&index=0&id=d0d4a346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0d4a346"]])

export default __exports__